import React from 'react'

function DS_program_details() {
  return (
    <div>

      {/* ---------------------------Mobile view--------------------- */}
      <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12'>
                <div className='text-center Program_details_1stcomp_text_mobile'>
                    <h1 className='display-6'>Master the Art of Data Science!</h1>
                    <p className='py-2'>Dive into the world of data science at Interns Elite. Unlock insights, transform careers. Enroll now for a data-driven journey and illuminate your path to a brighter future! </p>
                </div>
                <div className='mt-4 text-center Program_details_1stcomp_text_mobile'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>In this course on data science, you will take a deep dive into data collection methods, learn the fundamentals of Python, and refine your skills in data wrangling and visualization. Learn about the possibilities of deep learning, gain practical experience with BI tools, and develop web apps. Uncover the power of machine learning algorithms. This course, which combines theory with real-world experience and focuses on projects and applications, prepares you for a dynamic career in data science.</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-1 py-4'>
                <h1 className='Details_text text-center  pb-2 border-bottom'>Data Science </h1>
                  <div className='Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
      </div>

      {/* ----------------------Desktop View--------------------- */}
      <div className='d-none d-md-block'>
        <div className='container'>
          <div className='row'>
              <div className='col-md-8 detail_1stcomp_img'>
                  <div className='pt-3 Program_details_1stcomp_text'>
                      <h1 className='FS_@'>Master the Art of Data Science!</h1>
                      <p className='py-2'>Dive into the world of data science at Interns Elite. Unlock insights, transform careers. Enroll now for a data-driven journey and illuminate your path to a brighter future!</p>
                  </div>
                  <div className='mt-3 Program_details_1stcomp_text'>
                      <h1 className='display-4'>Overview</h1>
                      <p className='py-2'>In this course on data science, you will take a deep dive into data collection methods, learn the fundamentals of Python, and refine your skills in data wrangling and visualization. Learn about the possibilities of deep learning, gain practical experience with BI tools, and develop web apps. Uncover the power of machine learning algorithms. This course, which combines theory with real-world experience and focuses on projects and applications, prepares you for a dynamic career in data science.</p>
                  </div>
              </div>
              <div className='col-md-4'>
                  <div>
                  <div className=' Details_container shadow-lg px-3 py-4'>
                  <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Data Science</h1>
                    <div className='Details_text '>
                      <ul className='pt-3'>
                        <li>Live conversations with industry professionals</li>
                        <li className='py-3'>Project support and Guidance</li>
                        <li>Access to Specialized Course Materials</li>
                        <li className='py-3'>25+ Hours of Learning</li>
                        <li>Certificates from reputable MNC's around the world</li>
                      </ul>
                    </div>
                  </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DS_program_details
